import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import moment from 'moment';

const useIndicatorsYear = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [indicatorList, setIndicatorList] = useState<any[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  
  const { isLoading, refetch } = useQuery(
    [endpoints.management.indicators.year, [location.search]],
    () =>
      fetcher.management.postIndicatorYear({
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : moment().add(-2, 'year').format('YYYY-12-31'),   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : moment().add(-1, 'day').format('YYYY-MM-DD'),          
      }),
    {
      onSuccess: (res: indicatorListResDto) => {
        switch (res.code) {
          case 200:
            setIndicatorList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );


  return { indicatorList, refetch };
};

export default useIndicatorsYear;
